import api from '@/api'

const getOrganizationClients = function (org_id,params) {
  return api.get(`/organizations/${org_id}/clients`,{params})
}
const getClient = function (client_id) {
  return api.get(`/clients/${client_id}/`)
}
const getClients = function (params) {
  return api.get(`/clients`, {params})
}
const postOrganizationClient = function (org_id, params={}) {
  return api.post(`/organizations/${org_id}/clients`, params)
}
const patchClient = function (client_id, params={}) {
  return api.patch(`/clients/${client_id}`, params)
}
const deleteClient = function (client_id) {
  return api.delete(`/clients/${client_id}`)
}

export default {
  getClient,
  getClients,
  getOrganizationClients,

  postOrganizationClient,

  patchClient,

  deleteClient,

}
